import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromMipsQuestionnaire from '../../reducers/mips-questionnaire/mips-questionnaire.reducer';

export const selectMipsQuestionnaireState = createFeatureSelector<fromMipsQuestionnaire.State>(
    fromMipsQuestionnaire.mipsQuestionnaireFeatureKey
);

export const selectMipsQuestionnaire = createSelector(
    selectMipsQuestionnaireState,
    (state: fromMipsQuestionnaire.State) => state.mipsQuestionnaire
);

export const selectIsValid = createSelector(
    selectMipsQuestionnaireState,
    (state: fromMipsQuestionnaire.State) => state.isValid
);

export const selectIsQuestionnaireLoaded = createSelector(
    selectMipsQuestionnaireState,
    (state: fromMipsQuestionnaire.State) => state.isLoaded
);

export const selectIsLoading = createSelector(
    selectMipsQuestionnaireState,
    (state: fromMipsQuestionnaire.State) => state.isLoading
);

export const selectIsSubmitting = createSelector(
    selectMipsQuestionnaireState,
    (state: fromMipsQuestionnaire.State) => state.isSubmitting
);

export const selectError = createSelector(
    selectMipsQuestionnaireState,
    (state: fromMipsQuestionnaire.State) => state.error
);

export const selectSubmitSuccess = createSelector(
    selectMipsQuestionnaireState,
    (state: fromMipsQuestionnaire.State) => state.submitSuccess
);

export const selectCanSubmit = createSelector(
    selectMipsQuestionnaireState,
    (state: fromMipsQuestionnaire.State) => 
        state.isValid && !state.isSubmitting
);

